import styled from 'styled-components';

export const Wrapper = styled.div``;
export const SearchWrapper = styled.div`
	display: flex;
	gap: 3rem;
	margin-bottom: 4rem;
`;
export const StyledSelectWrapper = styled.div`
	flex: 1;
`;
